import { Injectable } from '@angular/core';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { VehicleEmissionTestModel } from '../models/vehicle-emission-test.model';
import { RegistrationTransactionBaseModel } from '../models/registration-transaction-base.model';
import { VehicleEmissionCheckStatusRegistrationModel } from '../models/vehicle-emission-check-status-registration.model';

@Injectable({
    providedIn: 'root'
})
export class VehicleEmissionsService extends BaseApiService {

    constructor() {
        super();
    }
    private handleError(error: HttpErrorResponse) {
        if (error.error) {
            return throwError(error.error);
        } else {
            return throwError('Server error');
        }
    }

    calculateEmissionExpiration = (emissionTest: VehicleEmissionTestModel) => this.post('TitleRegistration/Registration/Emission/Calculate', emissionTest);

    /**
     * Checks to see if the registration requires emissions data entry.
     * @param registration: Registration transaction model.
     */
    checkEmissionRequired = (registration: RegistrationTransactionBaseModel) => this.post('TitleRegistration/Registration/Emission/CheckRequired', registration);

    getEmissionsTestTypeAreaTypeMaps = () => this.get('TitleRegistration/Registration/EmissionTestTypeAreaTypeMaps').pipe(
        catchError(this.handleError));

    getEmissionTestTypeTestResultTypeMaps = () => this.get('TitleRegistration/Registration/EmissionTestTypeTestResultTypeMaps').pipe(
        catchError(this.handleError));

    getEmissionAreaTypeTestTypeTestResultTypeCertificateTypeMap = () => this.get('TitleRegistration/Registration/EmissionAreaTypeTestTypeTestResultTypeCertificateTypeMaps').pipe(
        catchError(this.handleError));

    getLatestEmissionTestByVehicleId = (vehicleId: number) => this.get('TitleRegistration/Registration/Emission/Vehicle/' + vehicleId + '/Latest').pipe(
        catchError(this.handleError));

    saveVehicleEmissionTest = (checkStatusModel: VehicleEmissionCheckStatusRegistrationModel) => this.post('TitleRegistration/Registration/Emission', checkStatusModel).pipe(catchError(this.handleError));
}
